import React from 'react';
import { Button, GDSIconSource } from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { WEB_COMMON_ASSET_KEYS } from '#types/assets.types.ts';

interface NoPeekCarouselNavButtonProps {
  disabled: boolean;
  onClick: () => void;
  label: string;
  icon: GDSIconSource;
}

interface NoPeekCarouselBackAndForwardNavButtonProps
  extends Omit<NoPeekCarouselNavButtonProps, 'label' | 'icon'> {}

const NavButton = ({
  disabled,
  onClick,
  label,
  icon,
}: NoPeekCarouselNavButtonProps) => (
  <Button
    css={{
      borderRadius: '$circle',
      justifyContent: 'center',
      transition: 'visibility 300ms, opacity 300ms',
      '&:disabled': {
        backgroundColor: 'unset',
        // Fixes a bug when the button is disabled and the icon is focused and you end up getting a white icon on white background.
        color: '$onSurfaceTextSubdued',
      },
      '@mobile': {
        padding: '$quarter',
      },
    }}
    textAlign="center"
    disabled={disabled}
    onClick={onClick}
    aria-label={label}
    quiet
    size="large"
    priority="tertiary"
    hideLabel
    icon={icon}
  >
    {label}
  </Button>
);

export const NoPeekCarouselBackNavButton = ({
  disabled,
  onClick,
}: NoPeekCarouselBackAndForwardNavButtonProps) => {
  const { formatMessage } = useIntl();
  const backNavIcon = useStaticAsset(
    WEB_COMMON_ASSET_KEYS.WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_BACK,
  ) as string;
  return (
    <NavButton
      disabled={disabled}
      onClick={onClick}
      label={formatMessage({ id: 'PREVIOUS' })}
      icon={backNavIcon}
    />
  );
};

export const NoPeekCarouselForwardNavButton = ({
  disabled,
  onClick,
}: NoPeekCarouselBackAndForwardNavButtonProps) => {
  const { formatMessage } = useIntl();
  const forwardNavIcon = useStaticAsset(
    WEB_COMMON_ASSET_KEYS.WEB_COMMON_NO_PEEK_CAROUSEL_NAV_ICON_FORWARD,
  ) as string;

  return (
    <NavButton
      disabled={disabled}
      onClick={onClick}
      label={formatMessage({ id: 'NEXT' })}
      icon={forwardNavIcon}
    />
  );
};
